import React, { useState } from 'react';
import ReasoningList from './ReasoningList';
import { PropTypes } from 'prop-types';
import { I18n } from 'aws-amplify';
import Utils from '@/common/utils/utils';

ThinkingInfo.propTypes = {
    reasoningData: PropTypes.any,
    defaultText: PropTypes.string,
    fontSize: PropTypes.string,
    color: PropTypes.string
};

export default function ThinkingInfo({
    reasoningData,
    defaultText = I18n.get('AI_THINKING'),
    fontSize = '13px',
    color = '#3C3C4399'
}) {
    const [showDetail, setShowDetail] = useState(false);
    
    const handleShowDetail = () => {
        if(reasoningData.length > 0){
            setShowDetail(!showDetail);
        }
    };

    return (
        <div style={{ display: 'inline-block', marginBottom: '10px' }}>

            {/* Text chính */}
            <div
                className='ai-thinking-text'
                style={{ fontSize, color, cursor: reasoningData.length > 0 ? 'pointer' : 'default' }}
                onClick={handleShowDetail}
            >
                <span>
                    {!Utils.isEmptyString(defaultText) ? defaultText : I18n.get('AI_THINKING')}
                </span>
            </div>

            {/* Detail: toggle khi click */}
            {showDetail && <ReasoningList reasoningData={reasoningData} />}
        </div>
    );
}
